var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5556 0.5H16.4444V14.0375L6.87202 4.46503L3.96503 7.37203L13.5374 16.9444H0V21.0556H13.5375L3.96503 30.628L6.87203 33.535L16.4444 23.9626V37.5H20.5556V23.9626L30.128 33.535L33.035 30.628L23.4625 21.0556H37V16.9444H23.4626L33.035 7.37202L30.128 4.46503L20.5556 14.0375V0.5Z",
    fill: "#044D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmm);
export default __webpack_public_path__ + "static/media/smm.089e8401e0a7a0b3d297568ff0f84764.svg";
export { ForwardRef as ReactComponent };